import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const sleepSteps = [
  {
    number: 1,
    title: 'Create Your Sanctuary',
    description: 'Lie down in a cool, dark, quiet space. Ensure your bed is comfortable and your environment conducive to sleep.'
  },
  {
    number: 2,
    title: 'Soft Eye Closure',
    description: 'Gently close your eyes. Let your eyelids become heavy and relaxed. Release any tension in your face.'
  },
  {
    number: 3,
    title: 'Breath Awareness',
    description: 'Focus on your natural breathing rhythm. Feel the gentle rise and fall of your chest and belly with each breath.'
  },
  {
    number: 4,
    title: 'Guided Relaxation',
    description: 'Allow the soothing voice to guide you through deep relaxation. Let go of thoughts and surrender to peaceful sleep.'
  }
];

const SleepingMeditationSession3: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Sleeping Meditation Session 3',
      description: 'Completed Sleeping Meditation Session 3.',
      image: require('../assets/sleeping.png').default || require('../assets/sleeping.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/sleeping-meditation');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 3: Sleep Meditation</h1>
              <p className="session-description">
                Journey into deep, healing sleep with this calming guided meditation. Release the day's worries and embrace restorative rest.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/KxfBZeTPNzM"
                  title="Session 3: Sleep Meditation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Meditate for Sleep</h2>
                <div className="session-steps">
                  {sleepSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SleepingMeditationSession3;

